import { useRequest } from "~/api/Request"
import API_V2 from "~/api/api-v2"
import {
  DocWorkflow02EventType,
  DocWorkflow03EventType,
  DocWorkflow04EventType,
  DocWorkflow05EventType,
  DocWorkflow06EventType,
  DocWorkflow07EventType,
  DocWorkflow10EventType,
  DocWorkflow13EventType,
  DocWorkflow11EventType,
  DocWorkflowNos,
  GenericActionTypes,
  DocWorkflow08EventType,
  DocWorkflow14EventType,
  DocWorkflow12EventType,
  DocWorkflow15EventType,
  DocWorkflow16EventType,
  DocWorkflow18EventType,
  DocWorkflow19EventType,
  DocWorkflow20EventType,
  DocWorkflow99EventType,
} from "~/model/ContractDocument"
import { FileObject, WorkflowActor } from "~/model/Workflow"
import { DocWorkflow01EventType } from "../model/ContractDocument"
import { CompanyType } from "~/model/Company"
import { UserType } from "~/components/template/video/Meet"
import { TransactionTypes } from "~/model/Contract"

export const actionGroups = {
  [DocWorkflowNos.DOC_WORKFLOW_01]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow01EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow01EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow01EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow01EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow01EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow01EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow01EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow01EventType.AgentRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow01EventType.AgentApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow01EventType.AgentRejectRequest,
      [GenericActionTypes.SIGN]: DocWorkflow01EventType.AgentVerifySignedDocument,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow01EventType.ContractorSignDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_02]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow02EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow02EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow02EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow02EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow02EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow02EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow02EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow02EventType.AgentRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow02EventType.AgentApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow02EventType.AgentRejectRequest,
      [GenericActionTypes.SIGN]: DocWorkflow02EventType.AgentVerifySignedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_03]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow03EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow03EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow03EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow03EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow03EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow03EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow03EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow03EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow03EventType.ContractorSignDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_04]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow04EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow04EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow04EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow04EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow04EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow04EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow04EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow04EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow04EventType.ContractorConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_05]: {
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow05EventType.AgentUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow05EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow05EventType.ContractorConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_06]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow06EventType.ManagerUploadMultiDocument,
      [GenericActionTypes.SEND]: DocWorkflow06EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow06EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow06EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow06EventType.ManagerRejectRequest,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow06EventType.AgentConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_07]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow07EventType.ManagerUploadDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_08]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow08EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow08EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow08EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow08EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow08EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow08EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow08EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SIGN]: DocWorkflow08EventType.AgentVerifySignedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow08EventType.AgentRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow08EventType.AgentApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow08EventType.AgentRejectRequest,
      [GenericActionTypes.SEND]: DocWorkflow08EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow08EventType.ContractorSignDocument,
    },
    [WorkflowActor.GUARANTEE_01]: {
      [GenericActionTypes.SIGN]: DocWorkflow08EventType.Guarantee01SignDocument,
    },
    [WorkflowActor.GUARANTEE_02]: {
      [GenericActionTypes.SIGN]: DocWorkflow08EventType.Guarantee02SignDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_09]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow08EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow08EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow08EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow08EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow08EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow08EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow08EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow08EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow08EventType.ContractorSignDocument,
    },
    [WorkflowActor.GUARANTEE_01]: {
      [GenericActionTypes.SIGN]: DocWorkflow08EventType.Guarantee01SignDocument,
    },
    [WorkflowActor.GUARANTEE_02]: {
      [GenericActionTypes.SIGN]: DocWorkflow08EventType.Guarantee02SignDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_10]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow10EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow10EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.RECEIVE]: DocWorkflow10EventType.ManagerConfirmReceivedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow01EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow01EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow10EventType.ManagerRejectRequest,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow10EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow10EventType.AgentSendDocumentToContractor,
      [GenericActionTypes.UPLOAD]: DocWorkflow10EventType.ManagerUploadDocument,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SEND]: DocWorkflow10EventType.ContractorSendDocumentToResident,
      [GenericActionTypes.SIGN]: DocWorkflow10EventType.ContractorSignDocument,
      [GenericActionTypes.CANCEL]: DocWorkflow10EventType.ContractorCancelSignByResident,
    },
    [WorkflowActor.RESIDENT]: {
      [GenericActionTypes.SIGN]: DocWorkflow10EventType.ContractorSignDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_12]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow12EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow12EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow12EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow12EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow12EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow12EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow12EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SIGN]: DocWorkflow12EventType.AgentVerifySignedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow12EventType.AgentRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow12EventType.AgentApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow12EventType.AgentRejectRequest,
      [GenericActionTypes.SEND]: DocWorkflow12EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow12EventType.ContractorSignDocument,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.SIGN]: {
        [TransactionTypes.DEDICATED_AGENT]: DocWorkflow15EventType.OwnerAgencySignDocument,
        [TransactionTypes.COLLECTION_AGENCY]: DocWorkflow15EventType.CollectionAgencySignDocument,
      },
      [GenericActionTypes.CANCEL]: DocWorkflow15EventType.CancelOwnerSign,
    },
    [WorkflowActor.OWNER]: {
      [GenericActionTypes.SIGN]: DocWorkflow12EventType.OwnerSignDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_13]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow13EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow13EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.RECEIVE]: DocWorkflow13EventType.ManagerConfirmReceivedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow01EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow13EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow13EventType.ManagerRejectRequest,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow13EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow13EventType.AgentSendDocumentToContractor,
      [GenericActionTypes.UPLOAD]: DocWorkflow13EventType.ManagerUploadDocument,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow13EventType.ContractorSignDocument,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow13EventType.OwnerAgencyConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_11]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow11EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow11EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow11EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow11EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow11EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow11EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow11EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SIGN]: DocWorkflow11EventType.AgentVerifySignedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow11EventType.AgentRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow11EventType.AgentApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow11EventType.AgentRejectRequest,
      [GenericActionTypes.SEND]: DocWorkflow11EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow11EventType.ContractorSignDocument,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow11EventType.OwnerAgencyConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_14]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow14EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow14EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow14EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow14EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow14EventType.ManagerRejectRequest,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow14EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow14EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow14EventType.ContractorConfirmReceivedDocument,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow14EventType.OwnerAgencyConfirmReceivedDocument,
    },
  },

  [DocWorkflowNos.DOC_WORKFLOW_15]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow15EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow15EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.RECEIVE]: DocWorkflow15EventType.ManagerConfirmReceivedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow15EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow15EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow15EventType.ManagerRejectRequest,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow15EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SIGN]: DocWorkflow15EventType.AgentVerifySignedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow15EventType.AgentRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow15EventType.AgentApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow15EventType.AgentRejectRequest,
      [GenericActionTypes.SEND]: DocWorkflow15EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow15EventType.ContractorSignDocument,
    },
    [WorkflowActor.GUARANTEE_01]: {
      [GenericActionTypes.SIGN]: DocWorkflow15EventType.Guarantee01SignDocument,
    },
    [WorkflowActor.GUARANTEE_02]: {
      [GenericActionTypes.SIGN]: DocWorkflow15EventType.Guarantee02SignDocument,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.SIGN]: {
        [TransactionTypes.DEDICATED_AGENT]: DocWorkflow15EventType.OwnerAgencySignDocument,
        [TransactionTypes.COLLECTION_AGENCY]: DocWorkflow15EventType.CollectionAgencySignDocument,
      },
      [GenericActionTypes.CANCEL]: DocWorkflow15EventType.CancelOwnerSign,
    },
    [WorkflowActor.OWNER]: {
      [GenericActionTypes.SIGN]: DocWorkflow15EventType.OwnerSignDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_16]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow16EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow16EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow16EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow16EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow16EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow16EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow16EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow16EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.SIGN]: DocWorkflow16EventType.ContractorSignDocument,
    },
    [WorkflowActor.GUARANTEE_01]: {
      [GenericActionTypes.SIGN]: DocWorkflow16EventType.Guarantee01SignDocument,
    },
    [WorkflowActor.GUARANTEE_02]: {
      [GenericActionTypes.SIGN]: DocWorkflow16EventType.Guarantee02SignDocument,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow16EventType.OwnerAgencyConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_17]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow14EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow14EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow14EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow14EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow14EventType.ManagerRejectRequest,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow14EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SEND]: DocWorkflow14EventType.AgentSendDocumentToContractor,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow14EventType.ContractorConfirmReceivedDocument,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow14EventType.OwnerAgencyConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_18]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow18EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow18EventType.ManagerSendDocumentToAgent,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow18EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow18EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow18EventType.ManagerRejectRequest,
      [GenericActionTypes.RECEIVE]: DocWorkflow18EventType.ManagerConfirmReceivedDocument,
    },
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow18EventType.AgentConfirmReceivedDocument,
      [GenericActionTypes.SIGN]: DocWorkflow18EventType.AgentVerifySignedDocument,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow18EventType.AgentRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow18EventType.AgentApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow18EventType.AgentRejectRequest,
    },
    [WorkflowActor.OWNER_AGENCY]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow18EventType.OwnerAgencyConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_19]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow19EventType.ManagerUploadDocument,
      [GenericActionTypes.SEND]: DocWorkflow19EventType.ManagerSendDocumentToContractor,
      [GenericActionTypes.REQUEST_APPROVAL]: DocWorkflow19EventType.ManagerRequestApproval,
      [GenericActionTypes.APPROVE]: DocWorkflow19EventType.ManagerApproveRequest,
      [GenericActionTypes.REJECT]: DocWorkflow19EventType.ManagerRejectRequest,
    },
    [WorkflowActor.CONTRACTOR]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow19EventType.ContractorReceiveDocument,
    },
    [WorkflowActor.GUARANTEE_01]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow19EventType.Guarantee01ReceiveDocument,
    },
    [WorkflowActor.GUARANTEE_02]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow19EventType.Guarantee02ReceiveDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_20]: {
    [WorkflowActor.AGENT]: {
      [GenericActionTypes.UPLOAD]: DocWorkflow20EventType.AgentUploadMultiDocument,
      [GenericActionTypes.SEND]: DocWorkflow20EventType.AgentSendDocumentToManager,
    },
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow20EventType.ManagerConfirmReceivedDocument,
    },
  },
  [DocWorkflowNos.DOC_WORKFLOW_99]: {
    [WorkflowActor.MANAGEMENT]: {
      [GenericActionTypes.RECEIVE]: DocWorkflow99EventType.ManagerConfirmReceivedDocument,
    },
  },
}

export function useStateMachine() {
  const { Request } = useRequest()
  return {
    sendAction: async (data: {
      contractDocumentId: number
      input: any
      genericAction: GenericActionTypes
      docWorkflowNo: DocWorkflowNos
      actor: WorkflowActor
      transactionType?: TransactionTypes
    }) => {
      const {
        contractDocumentId,
        input,
        genericAction,
        docWorkflowNo,
        actor,
        transactionType,
      } = data
      const url = API_V2.STATE_MACHINE_SEND_ACTION
      const actionType = actionGroups[docWorkflowNo][actor][genericAction]
      const response = await Request.post(url, {
        contractDocumentId,
        payload: {
          type: transactionType ? actionType[transactionType] : actionType,
          input,
        },
      })
      return response.data as any
    },
    batchSendDocument: async (data: { contractId: number; contractDocumentIds: number[] }) => {
      const { contractId, contractDocumentIds } = data
      const url = API_V2.STATE_MACHINE_BATCH_SEND_DOCUMENT

      const response = await Request.post(url, {
        contractId,
        contractDocumentIds,
      })
      return response.data
    },
    batchSendEvent: async (
      data: {
        contractDocumentId: number
        payload: any
      }[]
    ) => {
      const url = API_V2.STATE_MACHINE_BATCH_SEND_EVENT

      const response = await Request.post(url, data)
      return response.data
    },
  }
}
